export default __webpack_public_path__ + "static/media/exit.e9d264ca.svg";